// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

interface RfqQuoteDetailsTotalStyles {
    container?: GridContainerProps;
    fullWidthGridItem?: GridItemProps;
    subtotalLabelGridItem?: GridItemProps;
    subtotalValueGridItem?: GridItemProps;
    titleText?: TypographyProps;
    subtotalLabel?: TypographyProps;
    subtotalValue?: TypographyProps;
    wrapper?: InjectableCss;
    styledHr?: InjectableCss;
}

export const rfqQuoteDetailsTotalStyles: RfqQuoteDetailsTotalStyles = {};

const styles = rfqQuoteDetailsTotalStyles;

// XNG-Changes
const StyledHr = getStyledWrapper("hr");

const RfqQuoteDetailsTotal = ({ quoteState }: Props) => {
    if (!quoteState.value || quoteState.isLoading) {
        return null;
    }

    const quote = quoteState.value;

    return (
        <StyledWrapper {...styles.wrapper}>
            <GridContainer {...styles.container}>
                <GridItem {...styles.fullWidthGridItem}>
                    <Typography {...styles.titleText}>{translate("Order Summary")}</Typography>
                </GridItem>
                <GridItem {...styles.fullWidthGridItem} className="separator">
                    <StyledHr {...styles.styledHr} />
                </GridItem>
                <GridItem {...styles.subtotalLabelGridItem}>
                    <Typography {...styles.subtotalLabel}>{translate("Subtotal")}</Typography>
                </GridItem>
                <GridItem {...styles.subtotalValueGridItem}>
                    <Typography {...styles.subtotalValue}>{quote.orderSubTotalDisplay}</Typography>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(RfqQuoteDetailsTotal),
    definition: {
        displayName: "Total",
        allowedContexts: ["RfqQuoteDetailsPage"],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
